(function () {
    var body = document.body;
    if (!body) return;

    window.WP = {
        body: body,
        BASE: body.dataset.baseUrl || '',
        L: {
            ERR_NETWORK: body.dataset.lErrNetwork || 'Hálózati hiba — próbáld újra.',
            ERR_LOGIN:   body.dataset.lErrLogin   || 'Hibás felhasználónév vagy jelszó.',
            FORGOT_OK:   body.dataset.lForgotOk   || 'Ha létezik fiók ezzel az e-maillel, küldtünk egy linket.',
            FORGOT_INVALID_EMAIL: body.dataset.lForgotInvalidEmail || 'Kérjük, adj meg egy érvényes e-mail címet.',
            TAMOGATOM:   body.dataset.lTamogatom  || 'Támogatom'
        },

        triggerModal: function (modalId) {
            var t = document.querySelector('[data-modal-trigger="' + modalId + '"]');
            if (t) { t.click(); }
        },

        closeActiveModals: function () {
            document.querySelectorAll('.pw__modal.active').forEach(function (m) {
                var closer = m.querySelector('[data-modal-close]');
                if (closer) { closer.click(); }
            });
        },

        /**
         * A fejléc által TÉNYLEGESEN eltakart sáv magassága a viewport tetején.
         * A portál fejléce csak a `html.scrolled-down` állapotban fixed, és olyankor
         * a publicScroll() inline `top: -navMagassag`-gal fel is csúsztatja — tehát
         * nem takar semmit. Ezért nem a fejléc magasságát vonjuk le (ez volt a régi
         * `navH`), hanem azt mérjük, hogy a fix/sticky fejléc alja hol van a
         * viewportban: elcsúsztatott vagy nem létező fejléc esetén 0.
         */
        topOverlayHeight: function () {
            var els = document.querySelectorAll('.header, .navbar');
            var h = 0;
            for (var i = 0; i < els.length; i++) {
                var cs = window.getComputedStyle(els[i]);
                if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
                if (cs.display === 'none' || cs.visibility === 'hidden') continue;
                var r = els[i].getBoundingClientRect();
                if (r.height === 0 || r.bottom <= 0) continue; // felcsúsztatva = nem takar
                h = Math.max(h, r.bottom);
            }
            return h;
        },

        /**
         * Görgetés a hozzászólás-szekcióhoz. Ezt hívja a cikkoldal hozzászólás-ikonja
         * és az értesítő e-mail „Hozzászólok" gombja (?eact=comment) is.
         *
         * Három dolog miatt nem elég egy sima animate():
         *  - a cél a teljes szekció (`.readpost__comment-wrap`, benne a beírómezővel),
         *    nem csak a lista (`#ajax-post-comments`), különben a mező a viewport fölé esik;
         *  - a cikk törzsében a képeken nincs méret-attribútum, ezért DOM-ready-nél még
         *    mozog a layout — a mérés csak a teljes betöltés után pontos;
         *  - lefelé görgetéskor a publicScroll() felteszi a `html.scrolled-down`-t, amivel
         *    a fejléc kikerül a flowból és a `main` kap 90px padding-top-ot. A kettő
         *    különbsége (fejléc-magasság vs. 90px) a kijelző méretétől függ, és a görgetés
         *    KÖZBEN tolja el a célt. Ezért a görgetés végén utánamérünk és korrigálunk.
         *
         * @returns {boolean} false, ha nincs hozzászólás-szekció az oldalon
         *                    (pl. zárolt cikk) — a hívó ilyenkor nem tesz semmit.
         */
        scrollToComments: function () {
            var el = document.querySelector('.readpost__comment-wrap')
                  || document.getElementById('ajax-post-comments');
            if (!el) return false;

            var GAP = 16;        // kis levegő a szekció felett
            var MAX_PASS = 3;    // 1 görgetés + max 2 korrekció
            var TOLERANCE = 3;   // ennél kisebb eltérésért nem görgetünk újra

            function scrollY() {
                return window.pageYOffset
                    || document.documentElement.scrollTop
                    || document.body.scrollTop || 0;
            }

            function targetTop() {
                var want = el.getBoundingClientRect().top + scrollY()
                         - window.WP.topOverlayHeight() - GAP;
                var max = Math.max(0, (document.documentElement.scrollHeight || 0) - window.innerHeight);
                return Math.min(Math.max(0, want), max);
            }

            function pass(n) {
                var to = targetTop();
                if (Math.abs(to - scrollY()) <= TOLERANCE || n > MAX_PASS) return;
                var after = function () {
                    window.setTimeout(function () { pass(n + 1); }, 60);
                };
                if (window.jQuery) {
                    // Egy elemre animálunk (különben a complete kétszer fut le).
                    var scroller = document.scrollingElement || document.documentElement;
                    window.jQuery(scroller).stop(true).animate(
                        { scrollTop: to }, n === 1 ? 400 : 150, after
                    );
                } else {
                    window.scrollTo(0, to);
                    after();
                }
            }

            if (document.readyState === 'complete') {
                pass(1);
            } else {
                window.addEventListener('load', function () { pass(1); }, { once: true });
            }
            return true;
        }
    };
})();
